import React from 'react';
import { Select } from 'antd';
import * as Styled from './CustomSelect.styled';

export interface ICustomSelectProps {
  options?: any;
  placeholder?: string;
  filters?: boolean;
  size?: string;
  showSearch?: boolean;
  [rest: string]: any;
}

export const CustomSelect: React.FC<ICustomSelectProps> = ({
  options,
  placeholder,
  size,
  filters = false,
  showSearch = true,
  ...rest
}) => (
  <>
    {filters ? (
      <Styled.FiltersWrapper>
        <Select
          placeholder={placeholder}
          options={options}
          {...rest}
          showSearch={showSearch}
        />
      </Styled.FiltersWrapper>
    ) : (
      <Styled.SelectWrapper size={size}>
        <Select
          placeholder={placeholder}
          options={options}
          {...rest}
          showSearch={showSearch}
        />
      </Styled.SelectWrapper>
    )}
  </>
);
